import type {
  BrandCode,
  CaptureState,
  PaymentFilterOption,
  PaymentSearchByField,
  PaymentTypeKey,
  UiPaymentStatus,
} from '@models/payments';
import {
  BrandCodes,
  CaptureStates,
  PaymentSearchByFields,
  UiPaymentStatuses,
} from '@models/payments';

export const PAYMENT_TYPE_LABELS: Record<PaymentTypeKey, string> = {
  scheduledPayment: 'Standard',
  debtCollection: 'Debt Collection',
  subscriptionRecovery: 'Recurring Recovery',
};

export const PAYMENT_STATUS_LABELS: Record<UiPaymentStatus, string> = {
  [UiPaymentStatuses.SUCCEEDED]: 'Succeeded',
  [UiPaymentStatuses.PENDING]: 'Pending',
  [UiPaymentStatuses.FAILED]: 'Failed',
  [UiPaymentStatuses.REFUNDED]: 'Refunded',
  [UiPaymentStatuses.PARTIALLY_REFUNDED]: 'Partially Refunded',
};

export const PAYMENT_STATUS_OPTIONS: PaymentFilterOption<UiPaymentStatus>[] = [
  { value: 'all', label: 'All' },
  { value: UiPaymentStatuses.SUCCEEDED, label: 'Succeeded' },
  { value: UiPaymentStatuses.PENDING, label: 'Pending' },
  { value: UiPaymentStatuses.FAILED, label: 'Failed' },
  { value: UiPaymentStatuses.REFUNDED, label: 'Refunded' },
];

export const CAPTURE_STATE_LABELS: Record<CaptureState, string> = {
  [CaptureStates.CAPTURED]: 'Captured',
  [CaptureStates.AWAITING]: 'Awaiting capture',
  [CaptureStates.REQUESTED]: 'Capture requested',
  [CaptureStates.EXPIRED]: 'Capture window closed',
  [CaptureStates.MIGRATED]: 'Migrated (not captured here)',
  [CaptureStates.NOT_APPLICABLE]: 'No capture needed',
};

export const CAPTURE_STATE_OPTIONS: PaymentFilterOption<CaptureState>[] = [
  { value: 'all', label: 'All' },
  { value: CaptureStates.AWAITING, label: CAPTURE_STATE_LABELS[CaptureStates.AWAITING] },
  { value: CaptureStates.REQUESTED, label: CAPTURE_STATE_LABELS[CaptureStates.REQUESTED] },
  { value: CaptureStates.EXPIRED, label: CAPTURE_STATE_LABELS[CaptureStates.EXPIRED] },
  { value: CaptureStates.CAPTURED, label: CAPTURE_STATE_LABELS[CaptureStates.CAPTURED] },
  { value: CaptureStates.MIGRATED, label: CAPTURE_STATE_LABELS[CaptureStates.MIGRATED] },
];

export const PAYMENT_TYPE_OPTIONS: PaymentFilterOption<PaymentTypeKey>[] = [
  { value: 'all', label: 'All' },
  { value: 'debtCollection', label: 'Debt Collection' },
  { value: 'scheduledPayment', label: 'Standard' },
  { value: 'subscriptionRecovery', label: 'Recurring Recovery' },
];

export const BRAND_CODE_OPTIONS: PaymentFilterOption<BrandCode>[] = [
  { value: 'all', label: 'All' },
  ...Object.values(BrandCodes).map((value) => ({ value, label: value.toUpperCase() })),
];

export const PAYMENT_SEARCH_BY_OPTIONS: PaymentFilterOption<PaymentSearchByField>[] = [
  { value: PaymentSearchByFields.PAYMENT_ID, label: 'Payment ID' },
  { value: PaymentSearchByFields.PROVIDER_ID, label: 'Provider ID' },
  { value: PaymentSearchByFields.PAYMENT_SESSION_ID, label: 'Payment Session ID' },
  { value: PaymentSearchByFields.SUBSCRIPTION_ID, label: 'Subscription ID' },
  { value: PaymentSearchByFields.CUSTOMER_EMAIL, label: 'Customer email' },
  { value: PaymentSearchByFields.CUSTOMER_ID, label: 'Customer ID' },
  { value: PaymentSearchByFields.CUSTOMER_EXTERNAL_ID, label: 'Customer external ID' },
];
